import { pickBy, identity } from 'lodash';
import { httpV1 as http } from '@/services/api';

/** Notificações manuais recorrentes (diária/semanal/mensal), B2B-266. */

export async function list(params = {}) {
  const { page, per_page: perPage, title } = params;

  return http.get('/backoffice/notifications/schedules', {
    params: pickBy({ page, limit: perPage, title }, identity),
  });
}

export async function show(id) {
  return http.get(`/backoffice/notifications/schedules/${id}`);
}

export async function create(payload) {
  return http.post('/backoffice/notifications/schedules', payload);
}

export async function cancel(id) {
  return http.delete(`/backoffice/notifications/schedules/${id}`);
}
